/**
 * Skeleton — shimmering placeholder shown while an analysis loads, instead of a
 * blank screen or "Loading…" text. Uses the .ev-shimmer utility (theme-aware).
 */
const Bar = ({ h = 20, w = "100%", style }) => (
  <div className="ev-shimmer" style={{ height: h, width: w, borderRadius: 6, ...style }} />
);

const SkeletonTable = ({ rows = 9, cols = 6 }) => (
  <div style={{ padding: "0.25rem 0" }}>
    {/* header bar */}
    <Bar h={30} style={{ borderRadius: 8, marginBottom: "0.6rem" }} />
    {/* rows fade out slightly toward the bottom for a sense of depth */}
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} style={{ display: "flex", gap: "0.5rem", marginBottom: "0.4rem", opacity: Math.max(0.35, 1 - r * 0.07) }}>
        {Array.from({ length: cols }).map((_, c) => (
          <Bar key={c} h={18} w={c === 0 ? "18%" : "100%"} style={{ flex: c === 0 ? "0 0 18%" : 1 }} />
        ))}
      </div>
    ))}
  </div>
);

export default SkeletonTable;
